























































import { Component, Vue } from 'vue-property-decorator'
import CustomForm from '@/components/custom-form/index.vue'
import ShopApi from '@/api/shopInfo/index'
@Component({
  components: {
    CustomForm
  }
})
export default class EditShop extends Vue {
  form = {
    displayName: null,
    code: null,
    detailAddress: null,
    isActive: null
  }
  ruleForm = {
    name: [{ required: true, message: '请输入店铺名称', trigger: 'blur' }]
  }
  mounted() {
    // console.log((this.$route.query.storeInfo as any).displayName)
    // this.form.displayName = (this.$route.query.storeInfo as any).displayName
    // this.form.code = (this.$route.query.storeInfo as any).code
    // this.form.detailAddress = (this.$route.query.storeInfo as any).detailAddress
    // this.form.isActive = (this.$route.query.storeInfo as any).isActive
    this.getShopInfo()
  }
  getShopInfo() {
    ShopApi.getShopInfo(this.$route.query.id).then(res => {
      this.form = res.data
    })
  }
  submit() {
    let vm = this
    let form: any = vm.$refs.form
    form.validate(valid => {
      if (valid) {
        console.log('满足条件了', vm.form)
        ShopApi.editStoreInfo(
          this.$route.query.id,
          vm.form
        ).then(res => {
          console.log(res)
          if (res.status === 204) {
            this.$router.replace({
              name: 'shop'
            })
          }
        })
      }
    })
  }
}
